'use client';
import { useEffect, useMemo, useState } from 'react';

type DayEntry = { heading: string; date: string };

function extractDays(md: string): DayEntry[] {
  const lines = md.split('\n');
  const days: DayEntry[] = [];
  const re =
    /^###\s+(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday)\s+—\s+([0-9]{4}-[0-9]{2}-[0-9]{2})(?:\s*\(Today\))?\s*$/;
  for (const line of lines) {
    const m = line.match(re);
    if (m) {
      days.push({ heading: `${m[1]} — ${m[2]}`, date: m[2] });
    }
  }
  return days;
}

export function WeeklyInteractions({ content }: { content: string }) {
  const days = useMemo(() => extractDays(content), [content]);
  const [completed, setCompleted] = useState<Record<string, boolean>>({});

  useEffect(() => {
    try {
      const raw = localStorage.getItem('weekly-completed');
      if (raw) setCompleted(JSON.parse(raw));
    } catch {}
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem('weekly-completed', JSON.stringify(completed));
    } catch {}
  }, [completed]);

  const toggle = (date: string) => {
    setCompleted((prev) => ({ ...prev, [date]: !prev[date] }));
  };

  if (days.length === 0) return null;

  return (
    <div className="mt-2 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
      {days.map((d) => {
        const isDone = !!completed[d.date];
        return (
          <button
            key={d.date}
            onClick={() => toggle(d.date)}
            className={
              `rounded-full px-3 py-1 text-sm transition ` +
              (isDone
                ? 'bg-primary/15 text-primary hover:bg-primary/20'
                : 'bg-muted text-foreground hover:bg-muted/80')
            }
            aria-pressed={isDone}
          >
            {isDone ? 'Completed — ' : 'Mark Complete — '}
            {d.heading}
          </button>
        );
      })}
    </div>
  );
}

export default WeeklyInteractions;
